import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2ConfiguratorImageWithOverlays from './X46MK2ConfiguratorImageWithOverlays'
import ConfiguratorOption from './../ConfiguratorOption'
import Toggle from '../Toggle'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView02ImageOptions } from './views/ExteriorView02'

class X46MK2BowSprit extends Component {
  constructor (props) {
    super(props)
    this.handleBowspritChange = this.handleBowspritChange.bind(this)
  }

  handleBowspritChange (event) {
    let configuration = this.props.configuration
    configuration.Bowsprit = event.target.checked
      ? this.props.bowSpritOptions[1]
      : this.props.bowSpritOptions[0]

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = exteriorView02ImageOptions

    let image = (
      <X46MK2ConfiguratorImageWithOverlays
        boat='X46MK2'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Bowsprit' />
          </h1>

          <p>
            <Trans defaults='Hull topsides include 6 large hull portlights and a hull recessed anchor fitting hidden by GRP cowl, exchangeable with a carbon bowsprit to handle asymmetric spinnakers.' />
          </p>

          <p>
            <Trans defaults='This is a unique X-Yachts feature unparalleled by the competition.' />
          </p>
          <Toggle
            checked={this.props.configuration.Bowsprit.value === 2}
            onChange={this.handleBowspritChange}
          >
            {this.props.bowSpritOptions[1].label}
          </Toggle>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2BowSprit)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2BowSprit.js